  export class ObjectHashGenerator {
    // a simple hash function for any object that can be stringified
    public static hashNumberForObject(object: any) {
        const str = JSON.stringify(object);
        // tslint:disable-next-line:one-variable-per-declaration
        let hash = 0, i, chr;
        if (str.length === 0) { return hash; }
        for (i = 0; i < str.length; i++) {
        chr   = str.charCodeAt(i);
        // tslint:disable-next-line:no-bitwise
        hash  = ((hash << 5) - hash) + chr;
        // tslint:disable-next-line:no-bitwise
        hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
  }
